import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';

@Component({
  selector: 'app-attach-event-category',
  templateUrl: './attach-event-category.component.html',
  styleUrls: ['./attach-event-category.component.css']
})
export class AttachEventCategoryComponent implements OnInit {
  id: string;
  data: { key: string; order: number, isNew: boolean }[] = [];
  eventCategoriesSource: Array<any>
  constructor(
    private mmitaAssetService: MmitaAssetService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.getEventCategoriesSource()
    this.getAttachedEventData()
  }

  getEventCategoriesSource() {
    this.mmitaAssetService.getEventCategories().subscribe(res => {
      this.eventCategoriesSource = Object.keys(res).map(item => {
        return { label: item, value: item }
      });
    })
  }

  getAttachedEventData() {
    this.mmitaAssetService.getEventCategoriesByAssetId(this.id).subscribe((res: Array<{ key: string; order: number }>) => {
      this.data = res.map(item => {
        return { ...item, isNew: false }
      })
    });
  }

  updateAttachedInfo(data: { id: string; order: number }, categoryKey: string) {
    this.mmitaAssetService.updateAttachEventCategory(categoryKey, [data]).subscribe(res => {
      this.getAttachedEventData()
      this.toastr.success(`Updated`)
    });
  }

  removeAttachedItem(assetId: string, categoryKey: string) {
    this.mmitaAssetService.deleteEventCategory(categoryKey, [assetId]).subscribe(res => {
      this.getAttachedEventData()
      this.toastr.success(`Deleted`)
    });
  }


  addRow() {
    this.data.push({ key: null, order: 1, isNew: true });
  }

}
